// Handicap Graph
$(function() {
    /* BEGIN html header helper */
    let Handicap_Graph = {
        init: function() {
            let self = this;

            let chartElement = document.querySelector(
                "#handicap-overview-graph"
            );

            if (chartElement) {
                this.loadGraph(chartElement);
            }
        },

        loadGraph: function(chartElement) {
            let self = this;

            let context = chartElement.getContext("2d");

            // Prepare gradient under line
            let gradient = context.createLinearGradient(0, 0, 0, 80);
            gradient.addColorStop(0, "rgba(0,190,0,0.3)");
            gradient.addColorStop(1, "rgba(0,138,0,0)");

            let chartLabels = [
                "JAN 2019",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "JAN 2020"
            ];

            // Data points on graph
            let handicapData = [
                13,
                10,
                14,
                12,
                13,
                15,
                17,
                15,
                10,
                12,
                12,
                10,
                9
            ];

            let lineChart = new Chart(context, {
                type: 'line',
                data: {
                    labels: chartLabels,
                    datasets: [
                        {
                            data: handicapData,
                            backgroundColor: gradient,
                            borderColor: "#008A00",
                            borderWidth: 4,
                            lineTension: 0,
                            pointRadius: 0
                        }
                    ]
                },
                options: {
                    fullwidth: true,
                    layout: {
                        padding: {
                            top: 5
                        }
                    },
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [
                            {
                                position: "top",
                                gridLines: {
                                    drawBorder: false
                                    //zeroLineWidth: 0,
                                },
                                ticks: {
                                    autoSkip: false,
                                    display: false
                                }
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    drawBorder: true,
                                    display: false
                                },
                                ticks: {
                                    //beginAtZero: true,
                                    display: false
                                    //maxTicksLimit: 4,
                                }
                            }
                        ]
                    },
                    animation: {
                        duration: 0.5,
                        onComplete: function() {
                            /* Add and position custom labels */

                            let controller = this.chart.controller;
                            let chart = controller.chart;
                            let xAxis = controller.scales["x-axis-0"];

                            //@TODO - Roboto Condensed font not rendering
                            context.font = Chart.helpers.fontString(
                                16,
                                "700",
                                "'Roboto Condensed', Roboto, sans-serif"
                            );
                            context.fillStyle = "#aaa";

                            xAxis.ticks.forEach(function(value, index) {
                                if (index == 0) {
                                    let xOffset = 21;
                                    let yOffset = chart.height - 68;
                                    context.fillText(value, xOffset, yOffset);
                                }

                                if (index == xAxis.ticks.length - 1) {
                                    xOffset = chart.width - 85;
                                    yOffset = chart.height - 68;
                                    context.fillText(value, xOffset, yOffset);
                                }
                            });
                        }
                    }
                }
            });

            return this;
        }
    }.init();
});
